import * as React from "react";
import * as ReactDOM from "react-dom";

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import WithRouter from `~common/with-router`

// Authentication Views
import NotAuthorizedView from "~auth/views/not-authorized";
import LoginView from "~auth/views/login";
import LoginRenderer from "~auth/views/login-card-renderer";
import ResetPasswordWithToken from "~auth/views/reset-password-with-token";
import ForgotPasswordView from "~auth/views/forgot-password";
import MaintenanceMode from "~auth/views/maintenance-mode";

// Bulletins Views
import InvitePortalUserView from "~users/views/invite-portal-user";
import InviteBulkPortalUserView from "~users/views/invite-bulk-portal-user";

import UserRegisterView from "~users/views/register-portal-user";

// import UserSelfRegisterView from "~users/views/self-register-portal-user";
import UserSelfRegisterView from "~users/views/unsolicited-user-registration";
import UsersAdminView from "~users/views/user-admin";
import Preferences from "~users/views/preferences";
import GroupsAdminView from "~users/views/group-admin";
import FormsAdminView from "~forms/views/form-admin";
import DashboardView from "~dashboard/views/dashboard";
import BulletinsAdminView from "~bulletins/views/bulletin-admin";
import BulletinsList from "~bulletins/views/user-bulletins-list";
import LinksAdminView from "~links/views/links-admin";
import LinksList from "~links/views/user-links-list";
import FaqList from '~faq/views/faq-list';
import FAQAdminView from "~faq/views/faq-admin";
import ForceUserPasswordReset from "~users/views/force-all-user-reset"
import UserGroupFeatureReport from '~users/views/user-group-feature-report';
import UserInviteReportView from '~users/views/user-invite-report';
import UserLoginReportView from '~users/views/user-login-report';
import FailedLoginReportView from '~users/views/failed-login-report';
import TemplatesAdminView from "~templates/views/template-admin";

import {ExternalDefinitionSectionWindow} from '~forms/views/external-definition-section-window-fc';

import FeatureProxyAdmin from "~users/views/feature-proxy-admin"

import FeatureProxyAssignment from "~users/views/preferences-proxy-assignment-fc"

//pkg/portal/modules/root/modules/subscriptions/ui/views
import SubscriptionEditView from "../modules/subscriptions/ui/views/subscription-edit"
import UnsubscribeView from "../modules/subscriptions/ui/views/unsubscribe"
import UserSubscriptionList from "../modules/subscriptions/ui/views/user-subscription-list"
import SubscriptionList from "../modules/subscriptions/ui/views/subscription-list"

import MFAInit from "~auth/views/mfa-setup";

import CronScheduleView from '~common/components/cron-schedule-view'

CronScheduleView.register()
FeatureProxyAssignment.register()
LoginRenderer.register()

import MFAPreferences from "../modules/auth/ui/views/mfa-preferences"
MFAPreferences.register()

ReactDOM.render(( 
  <BrowserRouter>
    <Routes>

      <Route path='/users/enroll-otp' element={<MFAInit/>}/>
      <Route path='/users/mfa-enrollment-required' element={<MFAInit/>}/>
      <Route exact path='/' element={<DashboardView/> }/>
      <Route path='/feature-proxy/admin/:id' element={<WithRouter path='/feature-proxy/admin/:id' component={FeatureProxyAdmin } /> }/>
      <Route path='/feature-proxy/admin' element={<WithRouter path='/feature-proxy/admin' component={FeatureProxyAdmin } /> }/>
      
      {/* Authentication Module Views (imported from ~auth) */}
      <Route path='/not-authorized' element={<NotAuthorizedView/>} />
      <Route path='/login' element={<LoginView/>}/>
      <Route path='/users/reset/:id' element={<WithRouter path='/users/reset/:id' component={ResetPasswordWithToken } /> }/>
      <Route path='/maintenance-mode' element={<MaintenanceMode/> }/>

      {/* Users Module Views (imported from ~templates) */}
  
      <Route path='/users/report/features' element={<UserGroupFeatureReport/> }/>
      <Route path='/users/invite/bulk' element={<InviteBulkPortalUserView/> }/>
      <Route path='/users/invite/:id' element={<WithRouter path='/users/invite/:id' component={InvitePortalUserView }/>}/>
      <Route path='/users/register/:id' element={<WithRouter path='/users/register/:id' component={UserRegisterView }/>}/>
      <Route path='/users/self-register/:id' element={<WithRouter path='/users/self-register/:id' component={UserSelfRegisterView }/>}/>
      <Route path='/users/self-register' element={<WithRouter path='/users/self-register' component={UserSelfRegisterView }/>}/>
      <Route path='/users/invites/report' element={<UserInviteReportView/> }/>
      <Route path='/users/logins/report' element={<UserLoginReportView/> }/>
      <Route path='/users/failed-logins/report' element={<FailedLoginReportView/> }/>
      <Route path='/users/force-password-reset' element={<ForceUserPasswordReset/>} />
      
      {/* <Route path='/users/admin' element={UsersAdminView }/> */}

      <Route path='/users/admin/:id' element={<WithRouter path='/users/admin/:id' component={UsersAdminView }/>}/>
      <Route path='/users/admin' element={<UsersAdminView/> }/>
      <Route path='/groups/admin/:id' element={<WithRouter path='/groups/admin/:id' component={GroupsAdminView }/>}/>
      <Route path='/groups/admin' element={<GroupsAdminView/> }/>


      {/* Bulletins Module Views (imported from ~bulletins) */}
      <Route path='/bulletins/admin/:id' element={<WithRouter path='/bulletins/admin/:id' component={BulletinsAdminView }/>}/>
      <Route path='/bulletins/admin' element={<BulletinsAdminView/> }/>
      <Route path='/bulletins/list' element={<BulletinsList/> }/>

      {/* Bulletins Module Views (imported from ~links) */}
      <Route path='/links/admin/:id' element={<WithRouter path='/links/admin/:id' component={LinksAdminView }/>}/>
      <Route path='/links/admin' element={<LinksAdminView/> }/>
      <Route path='/links/list' element={<LinksList/> }/>

      {/* FAQ Module Views (imported from ~faq) */}
      <Route path='/faq/admin/:id' element={<WithRouter path='/faq/admin/:id' component={FAQAdminView }/>}/>
      <Route path='/faq/admin' element={<FAQAdminView/> }/>
      <Route path='/faq/list' element={<FaqList/> }/>

      {/* Forms Module Views (imported from ~forms) */}
      <Route path='/forms/admin/:id' element={<WithRouter path='/forms/admin/:id' component={FormsAdminView }/>}/>
      <Route path='/forms/admin' element={<WithRouter path='/forms/admin/:id' component={FormsAdminView }/>}/>

      {/* Definition Section External Viewer */}
      <Route path='/forms/definition-view' element={<ExternalDefinitionSectionWindow/> }/>

      {/* Templates Module Views (imported from ~templates) */}
      <Route path='/templates/admin/:id' element={<WithRouter path='/templates/admin/:id' component={TemplatesAdminView }/>}/>
      <Route path='/templates/admin' element={<WithRouter path='/templates/admin/:id' component={TemplatesAdminView }/>}/>
  

      {/* User Module Views (imported from ~users) */}
      {/* <Route path='/not-found' element={<NotFoundView/> }/> */}
      {/* <Route path='/forgot-password' element={<ForgotPasswordView/> }/> */}
      <Route path='/forgot-password' element={<WithRouter path='/forgot-password' component={ForgotPasswordView }/>}/>
      {/* <Route path='/portal-user-registration/:token' element={<PortalUserRegistration/> }/> */}
			{/* <Route path='/portal-user-registration' element={<PortalUserRegistration/> }/> */}
      {/* <Route path='/portal-user-invite' element={<PortalUserInvite/> }/> */}
      {/* <Route path='/preferences' element={<Preferences/> }/> */}
      <Route path='/preferences' element={<WithRouter path='/preferences' component={Preferences }/>}/>

      
      <Route path='/subscriptions/list' element={<UserSubscriptionList/> }/>
      <Route path='/subscriptions/admin/list' element={<SubscriptionList/> }/>
      <Route path='/subscriptions/unsubscribe/:id' element={<WithRouter path='/subscriptions/unsubscribe/:id' component={UnsubscribeView }/>}/>
      <Route path='/subscriptions/:id/:step' element={<WithRouter path='/subscriptions/:id/:step' component={SubscriptionEditView }/>}/>
      <Route path='/subscriptions/:id' element={<WithRouter path='/subscriptions/:id' component={SubscriptionEditView }/>}/>



    </Routes>
  </BrowserRouter>
), document.getElementById('container'))
